import { useId } from 'react'

import './Toggle.css'

interface ToggleProps {
  checked: boolean
  onChange: (checked: boolean) => void
  leftLabel?: string
  rightLabel?: string
  id?: string
}

export default function Toggle({
  checked,
  onChange,
  leftLabel,
  rightLabel,
  id
}: ToggleProps) {
  const generatedId = useId()
  const effectiveId = id || generatedId

  return (
    <div className="toggle-wrapper">
      {leftLabel && (
        <span
          className={`toggle-label ${!checked ? 'active' : ''}`}
          onClick={() => onChange(false)}
        >
          {leftLabel}
        </span>
      )}
      <label className="toggle-switch" htmlFor={effectiveId}>
        <input
          type="checkbox"
          id={effectiveId}
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span className="toggle-slider"></span>
      </label>
      {rightLabel && (
        <span
          className={`toggle-label ${checked ? 'active' : ''}`}
          onClick={() => onChange(true)}
        >
          {rightLabel}
        </span>
      )}
    </div>
  )
}
